import defaultAuth from "../../helpers/defaultAuth"
import {AUTH_UPDATE} from "../actions/AuthActions"
/** @description: Temp sync to redux until we remove all redux */
import "../syncToRedux"

const AuthenticationReducer = (state = defaultAuth, action: any) => {
  const {auth = {}} = action

  switch (action.type) {
    case AUTH_UPDATE:
      return auth || defaultAuth
    default:
      return state
  }
}

export default AuthenticationReducer
